import { put, take } from 'redux-saga/effects';

import { EXTRACT_AND_MODIFY_URL, SAVE_URL_PARAMS } from './actions';
import parseUrlQuery from 'Lib/parseUrlQuery';


function* extractAndModify() {
  while (true) {
    yield take(EXTRACT_AND_MODIFY_URL);

    const query = yield parseUrlQuery();

    yield put({ type: SAVE_URL_PARAMS, data: query });
    window._ref_id = query.rid;
  }
}


export default extractAndModify;
